<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5>{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary btn-buscar" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <hr class="mt-1" />    
    <div class="row">
    <div v-for="catalogo in catalogos" :key="'KeyIdentificador_' + catalogo.catalogoId" class="col-12">     
      <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">  
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales" id="PartidosJudiciales_div">
          <h6>Partido Judicial</h6>
          <C009PartidosJudiciales 
              :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" 
              v-on:valorParaElPadre="cambioDePartidoJudicialEvento" 
              v-on:valorParaElPadrePrimerElemento="cambioDePartidoJudicial"
              :prefijo="catalogo.etiquetaDeHtml" 
              :tipo="(area!= undefined && area!= null &&area.AreaId!=112 &&area.AreaId!=1)  ? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"
              :idDelInput="catalogo.idDelInput" 
              :parametros="parametros_PartidoJudicial.parametros" 
              :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" 
              :key="parametros_PartidoJudicial.key">
          </C009PartidosJudiciales>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados" id="Juzgados_div">
          <h6>Juzgado</h6>
          <C001Area 
            :class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeAreaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeArea"
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="(area!= undefined && area!= null &&area.AreaId!=112 &&area.AreaId!=1)  ? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"  
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Area.parametros" 
            :valorDefinido="parametros_Area.areaId" 
            :key="parametros_Area.key">
          </C001Area>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Materias" id="Materias_div">
          <h6>Materia</h6>
          <C002Materias 
            :class="[parametros_Materia.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeMateriaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeMateria" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="(area!= undefined && area!= null &&area.AreaId!=112 &&area.AreaId!=1)  ? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Materia.parametros" 
            :valorDefinido="parametros_Materia.materiaId" 
            :key="parametros_Materia.key">
          </C002Materias>
        </div>   


        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Delitos"  id="Delitos_div" class="form-group">
          

          <h6>Delito/os</h6>

 
          <div class="form-group">
          
           <multiselect 


           v-model="opcionesInputDelito.seleccionadas" 
           tag-placeholder="Delito no encontrado"
           placeholder="Seleccione el o los delitos" 
           label="valor" 
           track-by="llave" 
           :options="opcionesInputDelito.opciones" 
           :multiple="true" 
           :taggable="true"

           >
                        

           </multiselect>


    

           </div>

          <i  class="fas fa-redo fa-lg p-1 iconoHabilitado" title="Recargar"  @click="obtenerListaDeDelitos();"></i>

          

        </div > 


      
 
         <div v-if="catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos /*&& (parametros_Materia.materiaId > 0 || AccionesMostrar.consulta)*/" id="TiposDeDocumentos_div">
          <h6>Tipo de documento</h6>
          <C004TiposDocumento 
          :class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" 
          v-on:valorParaElPadre="cambioDeTipoDeDocumento" 
          :prefijo="catalogo.etiquetaDeHtml" 
          :tipo="catalogo.tipoDeSelect" 
          :idDelInput="catalogo.idDelInput" 
          :parametros="parametros_TipoDocumento.parametros" 
          :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" 
          :key="parametros_TipoDocumento.key"></C004TiposDocumento>
        </div>
        
         <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Municipios"  id="Municipios_div">
          <h6>Municipios</h6>
          <C010Municipios 
            :class="[parametros_Municipio.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeMunicipioEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeMunicipio" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Municipio.parametros" 
            :valorDefinido="parametros_Municipio.municipioId" 
            :key="parametros_Municipio.key">
          </C010Municipios>
        </div>


         <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Entidades"  id="Entidades_div">
          <h6>Entidades Federativas</h6>
          <C011EntidadesFederativas 
            :class="[parametros_Entidades.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeEntidadEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeEntidad" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Entidades.parametros" 
            :valorDefinido="parametros_Entidades.entidadId" 
            :key="parametros_Entidades.key">
          </C011EntidadesFederativas>
        </div>


        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Temporalidades"  id="Temporalidades_div">
          <h6>Temporalidad</h6>
          <C009TiposTemporalidad 
            :class="[parametros_Temporalidad.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeTemporalidadEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeTemporalidad" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Temporalidad.parametros" 
            :valorDefinido="parametros_Temporalidad.temporalidadId" 
            :key="parametros_Temporalidad.key">
          </C009TiposTemporalidad>
        </div>

        
        
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (parametros_TipoDocumento.tipoDocumentoId > 0 /*|| AccionesMostrar.consulta*/)" id="Consecutivo_div">
          <h6>Consecutivo</h6>
          <input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" />
        </div>

        <div class="form-group" v-if="mostrarNumeroExtra && catalogo.catalogoId == enumeraciones.catalogos.NumeroExtra && parametros_TipoDocumento.tipoDocumentoId > 0" id="NumeroExtra_div">
          <h6>Número</h6>
          <input class="form-control" type="text" placeholder="##" v-model="numeroExtra" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeNumeroExtra($event)" v-mask="'##'" />
        </div>


        <div class="form-group" v-if="(catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && parametros_Area.areaId==95 && (consecutivo && consecutivo.length == 9)  && (parseInt(consecutivo.split('/')[1]) <= 2020))">
        <h6>Número romano</h6>
        <input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="Ingrese el numero romano" @input="(text) => (numeroRomano = numeroRomano.toUpperCase())" @keypress="esRomano($event)"/>

             
        </div>


        <div class="form-group" v-if="(catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && parametros_Area.areaId==95 && (consecutivo && consecutivo.length == 9)  && (parseInt(consecutivo.split('/')[1]) <= 2020))">
        <h6>
        Nota: <br/><br/> Para el registro de expedientes del Juzgado de ejecución de penas y medidas de seguridad anteriores a 2021 deberá escribir:<br/><br/>
        I para los documentos provenientes del juzgado primero de ejecución<br/>
        II para los del juzgado segundo de ejecución

        </h6>  
        
        </div>



       </div>


       </div>


       





       


    

    <div class="col-12 form-group"  id="clave_del_procesado_anterior">
          <h6>Clave del Procesado Anterior</h6>
          <input class="form-control" type="text" placeholder="Ingrese la clave del procesado anterior" v-model="clave_del_procesado_anterior" id="clave_del_procesado_anterior" v-mask="'####'" />


    </div>

    <div class="col-12 form-group" id="nota_div">     
          <h6>Nota: si el procesado no cuenta con clave del procesado anterior no ingresar nada</h6>
          
    </div>

           
    <div class="col-12 form-group" id="nombre_div">     
          <h6>Nombre(s)</h6>
          <input class="form-control" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre" @input="(text) => (nombre = nombre.toUpperCase())" @keypress="esLetra($event)" />
    </div>

    <div class="col-12 form-group" id="apellido_paterno_div">
          <h6>Apellido Paterno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido paterno (al menos un apellido)" v-model="apellido_paterno" id="apellido_paterno" @input="(text) => (apellido_paterno = apellido_paterno.toUpperCase())" @keypress="esLetra($event)"  />
    </div>

    <div class="col-12 form-group" id="apellido_materno_div">
          <h6>Apellido Materno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido materno (al menos un apellido)" v-model="apellido_materno" id="apellido_materno" @input="(text) => (apellido_materno = apellido_materno.toUpperCase())" @keypress="esLetra($event)" />
    </div>

    <div class="col-12 form-group" id="nota_div">     
          <h6>Nota: si el procesado cuenta con solo un apellido no ingresar nada en el campo del otro apellido</h6>
          
    </div>


    <div class="col-12 form-group" id="direccion_div">
          <h6>Dirección</h6>
          <input class="form-control" type="text" placeholder="Ingrese la direccion" v-model="direccion" id="direccion" @input="(text) => (direccion = direccion.toUpperCase())" @keypress="esDireccion($event)" />
    </div>

   
    

        <div  class="col-12 form-group">
            
             <button type="button" class="btn btn-primary overwrapDeBotones mr-3 btn-buscar" @click="limpiarFiltros();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>

             <button type="button" v-if="(camposLlenos()) && (AccionesMostrar.guardar)" class="btn btn-success overwrapDeBotones mr-3"  @click="ejecutaLaFuncion()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>

             <!-- <button type="button"  class="btn btn-success overwrapDeBotones mr-3"  @click="ejecutaLaFuncion()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar Prueba</button> -->

        </div>


        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>



        
    </div>


  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import JQuery from 'jquery'
  import { servicioRestPost } from '../../Audiencias/Programacion/servicios/ServiciosHttp.js'
  import Multiselect from 'vue-multiselect'
  import func from './Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    directives: {
        tooltipF
    },
    data() {
      return {
        opcionesInputDelito: {
          delitosDB: [],
          opciones: [],
          seleccionadas: []
        },
        enumeraciones,
        consecutivo: "",
        numeroExtra: '',  
        numeroCarpeta: null,
        numeroRomano: null, 
        fechaInicial: moment().subtract(5, 'days').format('YYYY-MM-DD'),
        fechaFinal: moment().format('YYYY-MM-DD'),
        mostrarNumeroExtra: false,     
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: 1,
          parametros: {},
          esInformativo: true
        },
        parametros_Materia: {
          key: "",
          materiaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Delito: {
          key: "",
          delitoId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false,
        },
        parametros_Rubro: {
          key: "",
          rubroId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        },        
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {},
          esInformativo: false
        },

        parametros_Entidades: {
        key: "",
        entidadId: 1,   //entidadFederativaId es entidadId
        parametros: {},
          esInformativo: false
       },
        parametros_Municipio: {
        key: "",
        municipioId: -1,
        parametros: {},
          esInformativo: false
       },

       parametros_Temporalidad: {
        key: "",
        temporalidadId: -1,
        parametros: {},
          esInformativo: false
       },


        folioAcuerdo: null,
        nombre: null,
        
        apellido_paterno: null,
        apellido_materno: null,
        direccion: null,
        clave_del_procesado_anterior:null,
        checkboxclave: null,
        prueba:null     
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      C010Municipios: catalogos.PJ.C010Municipios,
      C011EntidadesFederativas: catalogos.PJ.C011EntidadesFederativas,
      C009TiposTemporalidad: catalogos.SIVAC.C009TiposTemporalidad,
      Multiselect
    },
    props: {
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      ejecutaLaFuncion: Function,
      ejecutalimpiarTablaResultados: Function,
      filtrosEstablecidos: Object,
      
      accionCancelar: {
        default: null,
        type: Object
      },
      AccionesMostrar:{            
        firma: false,
        pagos: false,
        consulta: false, 
        guardar: false,
        buscar: true         
      },
      area: null
    },
    mounted() {            
      if(this.elementosAOmitir){
        if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
          this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
          this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
        }
        if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
          this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
          this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
        }
      }          
      
      //this.parametros_Entidades.entidadId = 1;
      this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));

      // //this.parametros_PartidoJudicial.partidoJudicialId= 1;
      // this.cambioDePartidoJudicial(parseInt(this.parametros_PartidoJudicial.partidoJudicialId));

      
      /*this.parametros_Area.parametros.SistemaId = 38;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true; */
    },
    beforeMount()
    {
      if((this.area != undefined && this.area != null) && this.area.AreaId!=1 &&  this.area.AreaId!=112)
      {
        this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.AreaId = this.area.AreaId;
        this.parametros_Materia.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.conInactivos = true;


        if(this.elementosAConservar){ 

       
        
        if(this.elementosAConservar.materias && this.elementosAConservar.materias.length > 0){
          this.parametros_Materia.parametros.elementosAConservar = this.elementosAConservar.materias;
          this.parametros_Materia.key = "elementosAConservar_" + this.elementosAConservar.materias.length;     
        }


        }



      }
      else{



        if(this.elementosAConservar){ 

       
        // if(this.elementosAConservar.partidosJudiciales && this.elementosAConservar.partidosJudiciales.length > 0){
        //   this.parametros_PartidoJudicial.parametros.elementosAConservar = this.elementosAConservar.partidosJudiciales;
        //   this.parametros_PartidoJudicial.key = "elementosAConservar_" + this.elementosAConservar.partidosJudiciales.length;
        // }

        // Falta agregarlo en el catalogo de partidos

        
        if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
        }

        if(this.elementosAConservar.tiposDocumento && this.elementosAConservar.tiposDocumento.length > 0){
          this.parametros_TipoDocumento.parametros.elementosAConservar = this.elementosAConservar.tiposDocumento;
          this.parametros_TipoDocumento.key = "elementosAConservar_" + this.elementosAConservar.tiposDocumento.length;     
        }
        if(this.elementosAConservar.materias && this.elementosAConservar.materias.length > 0){
          this.parametros_Materia.parametros.elementosAConservar = this.elementosAConservar.materias;
          this.parametros_Materia.key = "elementosAConservar_" + this.elementosAConservar.materias.length;     
        }

        if(this.elementosAConservar.entidades && this.elementosAConservar.entidades.length > 0){
          this.parametros_Entidades.parametros.elementosAConservar = this.elementosAConservar.entidades;
          this.parametros_Entidades.key = "elementosAConservar_" + this.elementosAConservar.entidades.length;     
        }




      }
         


      }










    },
    async created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);        
      await Promise.resolve(this.obtenerListaDeDelitos());  
    },
    methods: {      
            
      /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       */
      limpiarFiltros: function(){




        if(this.area != undefined && this.area != null && (this.area.AreaId!=1 && this.area.AreaId!=112))
        {

        this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.AreaId = this.area.AreaId;
        this.parametros_Materia.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.conInactivos = true;


        this.parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
        this.parametros_TipoDocumento.parametros.AreaId = -1;
        this.parametros_TipoDocumento.parametros.MateriaId = -1;
        this.parametros_TipoDocumento.key +=1;
        this.parametros_TipoDocumento.tipoDocumentoId= -1;


        this.baseDeDatosId = null;
        this.numeroRomano = null;        

        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;   

        this.parametros_Delito.delitoId = -1;
        this.parametros_Delito.key += 1; 

        this.parametros_Rubro.rubroId = -1;
        this.parametros_Rubro.key += 1;

        this.parametros_Municipio.municipioId = -1;
        this.parametros_Municipio.key += 1;

        this.parametros_Entidades.entidadId = 1; //-1 //1 para cargar por defecto aguascalientes al limpiar el formulario
        this.parametros_Entidades.key +=-1;

        this.parametros_Temporalidad.temporalidadId = -1;
        this.parametros_Temporalidad.key +=-1;

        this.obtenerListaDeDelitos();





        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null;             
        this.numeroCarpeta = null; 
       
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null; 
        this.direccion = null;
        this.clave_del_procesado_anterior = null;
        
        // this.mensaje = null;
        // this.clavedelprocesado = null;          
        this.esAreaDeEjecucion = false;


        // this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));


        if(this.parametros_Entidades.entidadId==1){


          this.cambioDeMunicipio(parseInt(this.parametros_Municipio.municipioId));


        }

        else {


          this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));



        }



        }

        else{



        this.parametros_PartidoJudicial.partidoJudicialId = 1;
        this.parametros_PartidoJudicial.parametros.PartidoJudicialId = -1;
        this.parametros_PartidoJudicial.parametros.AreaId = -1;
        this.parametros_PartidoJudicial.parametros.MateriaId = -1;        
        this.parametros_PartidoJudicial.key += 1;      

        this.parametros_Materia.materiaId = -1; // 6


        this.parametros_Materia.parametros.PartidoJudicialId = -1;
        this.parametros_Materia.parametros.AreaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;       
        this.parametros_Materia.key += 1;

        this.parametros_Area.areaId = -1; // 12


        this.parametros_Area.parametros.PartidoJudicialId = -1;
        this.parametros_Area.parametros.AreaId = -1;
        this.parametros_Area.parametros.MateriaId = -1;        
        this.parametros_Area.key += 1;

        this.parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
        this.parametros_TipoDocumento.parametros.AreaId = -1;
        this.parametros_TipoDocumento.parametros.MateriaId = -1;   

        // this.parametros_TipoDocumento.parametros.elementosAConservar = [1,2,10,16,23,24];


        this.parametros_TipoDocumento.parametros.elementosAConservar = [1,5,23,27];
        this.parametros_Area.parametros.elementosAConservar = [12,95,54];
        this.parametros_PartidoJudicial.parametros.elementosAConservar = [1];
        this.parametros_Materia.parametros.elementosAConservar = [6,9];




        this.baseDeDatosId = null;
        this.numeroRomano = null;        

        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;   

        this.parametros_Delito.delitoId = -1;
        this.parametros_Delito.key += 1; 

        this.parametros_Rubro.rubroId = -1;
        this.parametros_Rubro.key += 1;

        this.parametros_Municipio.municipioId = -1;
        this.parametros_Municipio.key += 1;

        this.parametros_Entidades.entidadId = 1; //-1 //1 para cargar por defecto aguascalientes al limpiar el formulario
        this.parametros_Entidades.key +=-1;

        this.parametros_Temporalidad.temporalidadId = -1;
        this.parametros_Temporalidad.key +=-1;

        this.obtenerListaDeDelitos();





        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null;             
        this.numeroCarpeta = null; 
       
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null; 
        this.direccion = null;
        this.clave_del_procesado_anterior = null;
        
        // this.mensaje = null;
        // this.clavedelprocesado = null;          
        this.esAreaDeEjecucion = false;


        // this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));


        if(this.parametros_Entidades.entidadId==1){


          this.cambioDeMunicipio(parseInt(this.parametros_Municipio.municipioId));


        }

        else {


          this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));



        }






        }






      

        


      },


            /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        
        if (!this.parametros_PartidoJudicial.partidoJudicialId || this.parametros_PartidoJudicial.partidoJudicialId <= 0) 
          return false;

        if (!this.parametros_Materia.materiaId || this.parametros_Materia.materiaId <= 0) 
          return false;


        // if (!this.parametros_Delito.delitoId || this.parametros_Delito.delitoId <= 0) 
        //   return false;



        if (!this.opcionesInputDelito.seleccionadas || this.opcionesInputDelito.seleccionadas <=0)
          return false;

        if (!this.parametros_Area.areaId || this.parametros_Area.areaId <= 0) 
          return false;

        if (!this.parametros_TipoDocumento.tipoDocumentoId || this.parametros_TipoDocumento.tipoDocumentoId <= 0) 
          return false;

        if (!this.parametros_Entidades.entidadId || this.parametros_Entidades.entidadId <= 0) 
          return false;

        if (!this.parametros_Municipio.municipioId || this.parametros_Municipio.municipioId <= 0) 
          return false;

        if (!this.parametros_Temporalidad.temporalidadId || this.parametros_Temporalidad.temporalidadId <= 0) 
          return false;

        if (!this.nombre || this.nombre <= 0) 
          return false;

        if ((!this.apellido_paterno || this.apellido_paterno <= 0) && (!this.apellido_materno || this.apellido_materno <= 0)) 
           return false; 

        if (!this.direccion || this.direccion <= 0) 
          return false;

        if (!this.consecutivo || this.consecutivo <= 0) 
          return false;



        
        return true;
      },
      




      /**
       * Método encargado de actualizar/cambiar el campo del Consecutivo.
       * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       */
      cambioDeConsecutivo(datos) { 
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Partido Judicial
       * @param {event.target} datos [datos: nuevo valor del Partido Judicial]
       */
      cambioDePartidoJudicialEvento(datos) {
        this.cambioDePartidoJudicial(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id Partido Judicial
       * @param {int} id [id: identificador del Partido Judicial]
       */
      cambioDePartidoJudicial(id) {
        this.parametros_PartidoJudicial.partidoJudicialId = id;

        //Actualizo area
        /**/
        this.parametros_Area.areaId = -1; 
        this.parametros_Area.parametros.AreaId = -1;   
        this.parametros_Area.key += 1;
        /**/
        this.parametros_Area.parametros.PartidoJudicialId = id;
        this.parametros_Area.key = "PartidoJudicial_" + id;        

        /**/
        this.parametros_Materia.materiaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;    
        this.parametros_Materia.key += 1; 
        
        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;
        /**/
      },            
      /**
       * Método encargado de actualizar/cambiar el campo Materia
       * @param {event.target} datos [datos: nuevo valor del Materia]
       */
      cambioDeMateriaEvento(datos) {
        this.cambioDeMateria(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Materia
       * @param {int} id [id: identificador del Materia]
       */
      cambioDeMateria(id) {
        this.parametros_Materia.materiaId = id;
        
        //Actualizo area
        this.parametros_Area.parametros.MateriaId = id;
        if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_Area.key = "Materia_" + id;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = id;
        if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_TipoDocumento.key = "Materia_" + id;
        

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0)
            this.obtenerFiltradoTipoDeDocumentosAPI();
      },
      /**
       * Método encargado de actualizar/cambiar el campo Area
       * @param {event.target} datos [datos: nuevo valor del Area]
       */
      cambioDeAreaEvento: function(datos) {
        this.cambioDeArea(parseInt(datos.target.value));

        if(this.parametros_Area.areaId==12){
         this.numeroRomano = null;
         }
      },
      /**
       * Método encargado de actualizar/cambiar el id de Area
       * @param {int} id [id: identificador del Area]
       */
      cambioDeArea: function(id) {
        this.parametros_Area.areaId = id;

        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = id;
        if (this.parametros_PartidoJudicial.partidoJudicialId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_PartidoJudicial.key = "Area_" + id;

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = id;
        /**/
        this.parametros_Materia.materiaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;    
        this.parametros_Materia.key += 1; 
        /**/        
        this.parametros_Materia.key = "Area_" + id;          

        if(this.parametros_Area.areaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
          this.esAreaDeEjecucion = true;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.AreaId = id;
        /**/
        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;
        /**/
        this.parametros_TipoDocumento.key = "Area_" + id;

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0)     
              this.obtenerFiltradoTipoDeDocumentosAPI();
      },      
      /**
       * Método encargado de actualizar/cambiar el campo Tipo de Documento
       * @param {event.target} datos [datos: nuevo valor del Tipo de Documento]
       */
      cambioDeTipoDeDocumento(datos) {
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0)
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;

        //Mostramos número extra de consecutivo si es Tercería o Incidente.
        if(this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente)
          this.mostrarNumeroExtra = true;
        else
          this.mostrarNumeroExtra = false;



        if(this.parametros_TipoDocumento.tipoDocumentoId==-1){
         this.consecutivo = null;
         }        
      }, 
      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SIVAC.sistema.administracion.firmas.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      /**
       * Método encargado de actualizar/cambiar el campo Delito
       * @param {event.target} datos [datos: nuevo valor del Delito]
       */
      cambioDeDelitoEvento(datos){
        this.cambioDeDelito(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Delito
       * @param {int} id [id: identificador del Delito]
       */
      cambioDeDelito(id){
        this.parametros_Delito.delitoId = id; 
      },


     /**
       * Método encargado de actualizar/cambiar el campo Municipio
       * @param {event.target} datos [datos: nuevo valor del Municipio]
       */
      cambioDeMunicipioEvento(datos){
        this.cambioDeMunicipio(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Municipio
       * @param {int} id [id: identificador del Municipio]
       */
      cambioDeMunicipio(id){
        this.parametros_Municipio.municipioId = id; 
      },



      /**
       * Método encargado de actualizar/cambiar el campo Entidad
       * @param {event.target} datos [datos: nuevo valor del Entidad]
       */
      cambioDeEntidadEvento(datos){
        this.cambioDeEntidad(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Entidad
       * @param {int} id [id: identificador del Entidad]
       */
      cambioDeEntidad(id){
        this.parametros_Entidades.entidadId = id; 

        //Actualizo municipio
        /**/
        this.parametros_Municipio.municipioId = -1; 
        this.parametros_Municipio.parametros.MunicipioId = -1;   
        this.parametros_Municipio.key += 1;
        /**/
        this.parametros_Municipio.parametros.EntidadFederativaId = id;
        this.parametros_Municipio.key = "EntidadFederativaId_" + id;


      },


      /**
       * Método encargado de actualizar/cambiar el campo Entidad
       * @param {event.target} datos [datos: nuevo valor del Entidad]
       */
      cambioDeTemporalidadEvento(datos){
        this.cambioDeTemporalidad(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Entidad
       * @param {int} id [id: identificador del Entidad]
       */
      cambioDeTemporalidad(id){
        this.parametros_Temporalidad.temporalidadId = id; 
      },




       
      /***********/
      /**
       * Método encargado de actualizar/cambiar el campo Numero Extra
       * @param {event.target} datos [datos: nuevo valor del Numero Extra]
       */
      cambioDeNumeroExtra(datos) {
        this.$store.dispatch("A_Comun_NumeroExtra", datos.target.value);
      },


      esLetra(datos){
        return func.esLetra(datos)
      },


      esDireccion(datos){
        return func.esDireccion(datos)
      },

      esRomano(datos){
        return func.esRomano(datos)
      },



      /*,      
      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Fecha',
        'A_Comun_Consecutivo',
        'A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado',
        'A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia'
      ])*/


      obtenerListaDeDelitos: async function() {
        this.opcionesInputDelito.opciones = [];
        this.opcionesInputDelito.seleccionadas = [];
        this.opcionesInputDelito.delitosDB  = [];

         try 
         {

            let peticionAPI = { ...this.parametros_Delito.parametros };
            peticionAPI.EsPrueba = false;
            // console.log('peticionAPI::', peticionAPI);
            const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.PJ.catalogos.C008Delitos,
                peticionServicio: peticionAPI,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));

            if(!CON_ERROR && RESPUESTA.Delitos != null && RESPUESTA.Delitos != undefined && RESPUESTA.Delitos.length > 0) {
              this.opcionesInputDelito.delitosDB = RESPUESTA.Delitos;
              this.opcionesInputDelito.opciones = this.opcionesInputDelito.delitosDB.map(dObj => {
                let delitoOpcion = {};
                delitoOpcion.llave = dObj.DelitoId;
                delitoOpcion.valor = dObj.Nombre;
                return delitoOpcion;
              });
              // console.log('obtenerListaDeDelitos::',this.opcionesInputDelito.opciones);
            }
        }
        catch(e) {
            console.error(e);
         }
      }



    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"> </style>

<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
  </style>


<style >
  
  .multiselect__tags {
      background:var(--blanco-pj) !important;
      border: none !important ;
      font-size: 0.9rem !important;
      padding: 0 0.75rem;
      min-height: calc(2rem);

     
  }


  .multiselect__option {
   
    font-size: 0.9rem !important;
    min-height: calc(2rem) !important;
    line-height: 0.9rem !important;

 
 }




  /*.multiselect__select {

    color:aqua !important;


  }*/

  .multiselect__placeholder{
    color:  black !important;
  }


  .multiselect__option--selected {
    background: var(--blanco-pj) !important;
    color: #35495e;
   /* font-weight: 700;*/
}


.multiselect__select:before {
    border-color: #FFF transparent transparent;
    
}


.multiselect__content-wrapper {
   
    background: #FFF !important;
   
}


.multiselect__option--highlight {
    background: #007bff !important;
}

.btn-buscar{
    background-color: var(--gris-pj);
  }


  

  </style>




  







// WEBPACK FOOTER //
// src/components/SIVAC/Comun/FiltroAltaFirmas.vue